import React, { FC, ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import withLocalization from '../../components/hoc/withLocalization';
import ConfirmationHeader from '../../components/OfferConfirmation/ConfirmationHeader';
import StartOver from '../../components/OfferConfirmation/StartOver';
import { NavigationSteps } from '../../components/OfferDetails/OfferNavigation';
import ContactInformationReview from '../../components/OfferSummary/ContactInformationReview';
import PackageSummaryReview from '../../components/OfferSummary/PackageSummaryReview';
import { RootState } from '../../redux/rootReducer';
import { setNavigationStep } from '../offerSearch/offerSearchSlice';

const OfferConfirmationContainer: FC<any> = (props: any): ReactElement => {
  const confirmationNumber = useSelector((state: RootState) => state.confirmation.ConfirmationNumber);
  const { localize } = props;
  const comments = useSelector((state: RootState) => state.confirmation.comments);
  const dispatch = useDispatch();
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(setNavigationStep(NavigationSteps.OFFER_CONFIRMATION));
  });
  return (
    <>
      <div className="container">
        <ConfirmationHeader confirmationNumber={confirmationNumber} />
        <div className="row">
          <div className="col-sm-6">
            <ContactInformationReview />
          </div>
          <div className="col-sm-6">
            <PackageSummaryReview />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 commentsWrapper">
            {comments ? (
              <div>
                <h5>{localize('preview-sales-engine.static-content.copy.Labels.labels#comments')}</h5>
                <p>{comments}</p>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
        <StartOver />
      </div>
    </>
  );
};
export default withLocalization(OfferConfirmationContainer);
